// extracted by mini-css-extract-plugin
module.exports = {"icon":"OpenInNewTabButton_icon__ivlcm"};